import React, { useState } from 'react'
import { getBaseUrl } from '../../Utils'
import { FoundationsEnums } from '../../enum'
import { useAddBusinessParameterMutation } from '../../Redux/Admin_Tasks/BusinessParameterSlice'
import DatePicker from '../../Components/DatePicker/DatePicker'
import { FoundationsButton } from '../../GenericComponents/button' //Done
import { FoundationsInput } from '../../GenericComponents/input'
import FoundationsSelect from '../../GenericComponents/select'
import { FoundationsCheckBox } from '../../GenericComponents/checkbox'
import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster'
import { useTitleContext } from "../../Hooks/useTitleContext";


declare let window: any
const UnicornApp = window.unicornInstance as any
interface formData {
    name: string
    description: string
    sourceId: string
    scopeId: string
    dataType: string
    bpValue: string
    validUntil: string
    isSecured: boolean
    bpscopedepartment: string
    ScopeName: string
}
const ManageBusinessParameters: React.FC = () => {
    const [fielderror, setfielderror] = useState('')
    const [validationMessage, setValidationMessage] = useState('')
    const [addBusinessParameter, {}] = useAddBusinessParameterMutation()
    const [formData, setFormData] = useState<formData>({
        name: '',
        description: '',
        sourceId: '1',
        scopeId: '',
        dataType: '',
        bpValue: '',
        validUntil: '',
        isSecured: false,
        bpscopedepartment: '',
        ScopeName:'Company Wide' ,
    })
    const [errors, setErrors] = useState({
        name: '',
        dataType: '',
        bpValue: '',
    })
    const dataTypeMessages = {
        HLCount: 'Up to 10 digits of numbers (without decimals) allowed.',
        HLNumber: 'Up to 10 digits of numbers (with or without decimals) allowed.',
        HLDuration:'Allowed format: dd:hh:mm.ss <br/>Example: <strong>2d:8h:25m</strong> means 2 days, 8 hours and 25 minutes',
        HLMoney: 'Up to 10 digits of numbers with 2 decimals allowed. <br/>No currency symbol allowed.',
    }
    const validateName = () => {
        return formData.name.trim() === '' ? 'Please enter a name.' : ''
    }

    const validateDataType = () => {
        return formData.dataType.trim() === '' ? 'Please select a valid data type.' : ''
    }

    const validateBPValue = () => {
        let regEx
        const datatypefield = FoundationsEnums.HLDataType[formData.dataType as any]
        switch (datatypefield) {
            case 'HLCount':
                regEx = /^\d{1,10}$/
                break
            case 'HLNumber':
                regEx = /^\d{1,10}(?:\.\d{1,2})?$/
                break
            case 'HLDuration':
                regEx =
                    /^(?:(\d{1,3}[dD])(?::([01]?\d|2[0-3])[hH](?::([0-5]?\d)[mM](?::([0-5]?\d)[sS])?)?)?|([01]?\d|2[0-3])[hH](?::([0-5]?\d)[mM](?::([0-5]?\d)[sS])?)?|([0-5]?\d)[mM](?::([0-5]?\d)[sS])?|([0-5]?\d)[sS])$/
                break
            case 'HLMoney':
                regEx = /^\d{1,8}(\.\d{2})$|^100000000(\.00)?$/
                break
            default:
                return 'Please enter a valid value.'
        }
        return regEx.test(formData.bpValue)
            ? ''
            : 'Please enter a valid value'
    }

    const { setTitle } = useTitleContext();
    setTitle("Business Parameter");

    const validateForm = () => {
        const nameError = validateName()
        const dataTypeError = validateDataType()
        const bpValueError = validateBPValue()

        setErrors({ name: nameError, dataType: dataTypeError, bpValue: bpValueError })

        return !nameError && !dataTypeError && !bpValueError
    }

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value, type } = e.target
        let selectedText = ''
        if (e.target instanceof HTMLSelectElement) {
            const selectElement = e.target as HTMLSelectElement
            selectedText = selectElement.options[selectElement.selectedIndex].text
        }

        const updatedValue = type === 'checkbox' ? (e.target as HTMLInputElement).checked : value
        setFormData((prev) => ({
            ...prev,
            [name]: updatedValue,
            ...(name === 'scopeId' && { ScopeName: selectedText }),
            ...(name === 'bp_scope_department' && { ScopeName: selectedText }),
        }))
        setErrors((prev) => ({
            ...prev,
            [name]: '',
        }))
        if (name === 'dataType') {
            const selectedTypeID = value as any
            const selectedType = FoundationsEnums.HLDataType[selectedTypeID]

            setValidationMessage(
                dataTypeMessages[selectedType as keyof typeof dataTypeMessages] || ''
            )
        }
    }

    const handleDateChange = (newDate: string) => {
        setFormData((prev) => ({
            ...prev,
            validUntil: newDate,
        }))
    }
    const handleSave = async () => {
        document.title = 'Foundations - Manage Business Parameters'
        if (!validateForm()) {
            setfielderror('Please correct the errors below and try again.')
            return
        }

        try {
            await addBusinessParameter(formData).unwrap()
            FoundationsGenericToaster('success', 'Business parameter added successfully')
            setTimeout(() => {
                window.location.href = getBaseUrl() + `/ux/index.html#BusinessParameters`
            }, 300)
        } catch (error) {
            console.error('Failed to add parameter:', error)
            FoundationsGenericToaster('error', 'Sorry, Business parameter adding failed.')
        }
    }

    const handleCancel = () => {
        window.location.href = getBaseUrl() + `/ux/index.html#BusinessParameters`
    }

    return (
        <>
            <div className="float-right margin-top-small">
                <a
                    id="link_backto_admin_tasks"
                    className="cursor-pointer"
                    href={`${getBaseUrl()}/ux/index.html#AdminTasks`}
                >
                    &laquo; Back to Admin Tasks
                </a>
            </div>
            <div className="row">
                <div className="col">
                    <div className="header">Manage Business Parameters</div>
                </div>
            </div>
            <div id="page_initial_content" className="include-bootstrap">
                <div>
                    <div className="content">
                        <div className="float-left"></div>

                        <div className="float-left"></div>
                    </div>
                </div>
            </div>

            <div className="float-right margin-top-small">
                <a
                    id="BusinessParameters"
                    className="back-to-BP"
                    href={`${getBaseUrl()}/ux/index.html#BusinessParameters`}
                >
                    &laquo; Back to Business Parameters
                </a>
            </div>
            <br></br>
            <br></br>

            <h5 className="col-sm-offset-1" style={{ marginLeft: '11%' }}>
                Add Business Parameter
            </h5>
            <p
                className="status-box-error margin-bottom-large"
                style={{ display: fielderror ? 'block ' : 'none' }}
            >
                {fielderror}
            </p>
            <div className="container">
                <div className="form-horizontal center-block">
                    <div className="form-group row mt-2">
                        <label className="col-sm-2 text-right control-label">Name:</label>
                        <div className="col-sm-5">
                            <FoundationsInput
                                type="text"
                                inputClasses="form-control"
                                id="bp_name"
                                name="name"
                                value={formData.name}
                                onInput={(e: any) => {
                                    handleInputChange(e)
                                }}
                                maxLength={50}
                                inputStyle={{ height: '30px', width: '450px' }}
                            />
                            <div
                                id="valmsg_bp_name"
                                className="field-validation-error"
                                style={{ display: errors.name ? 'block' : 'none' }}
                            >
                                {errors.name}
                            </div>
                        </div>
                    </div>
                    <div className="form-group row mt-2">
                        <label className="col-sm-2 text-right control-label">Description:</label>
                        <div className="col-sm-5">
                            <FoundationsInput
                                type="text"
                                inputClasses="form-control"
                                id="bp_description"
                                name="description"
                                value={formData.description}
                                onInput={(e: any) => {
                                    handleInputChange(e)
                                }}
                                maxLength={100}
                                inputStyle={{ height: '30px', width: '450px' }}
                            />
                        </div>
                    </div>
                    <div className="form-group row mt-2">
                        <label className="col-sm-2 text-right control-label">Source:</label>
                        <div className="col-sm-4">
                            <FoundationsSelect
                                id="bp_source"
                                selectClasses="chzn-select"
                                value={formData.sourceId}
                                name="sourceId"
                                onChange={(e: any) => {
                                    handleInputChange(e)
                                }}
                                customStyles={{
                                    width: '200px',
                                    borderColor: '#D3D3D3',
                                    borderRadius: '5px',
                                }}
                            >
                                <option value="1">Customer Generated</option>
                            </FoundationsSelect>
                        </div>
                    </div>

                    <div className="form-group mt-2 row">
                        <label htmlFor="bp_scope" className="control-label col-sm-2 text-right">
                            Scope:
                        </label>
                        <div className="col-sm-4">
                            <FoundationsSelect
                                id="bp_scope"
                                selectClasses="chzn-select"
                                name="scopeId"
                                value={formData.scopeId}
                                onChange={(e: any) => {
                                    handleInputChange(e)
                                }}
                                customStyles={{
                                    width: '200px',
                                    borderColor: '#D3D3D3',
                                    borderRadius: '5px',
                                }}
                            >
                                <option value="0">Company Wide</option>
                                <option value="1">Based on Department</option>
                            </FoundationsSelect>
                        </div>

                        {formData.scopeId === '1' && (
                            <div className="col-sm-3" style={{ marginLeft: '-130px' }}>
                                <FoundationsSelect
                                    id="bp_scope_department"
                                    selectClasses="form-control"
                                    name="bp_scope_department"
                                    value={formData.dataType}
                                    onChange={(e: any) => {
                                        handleInputChange(e)
                                    }}
                                    customStyles={{
                                        width: '200px',
                                        borderColor: '#D3D3D3',
                                        borderRadius: '5px',
                                    }}
                                >
                                    <option value={FoundationsEnums.departments.Radiology}>
                                        {
                                            FoundationsEnums.departments[
                                                FoundationsEnums.departments.Radiology
                                            ]
                                        }
                                    </option>
                                    <option value={FoundationsEnums.departments.Cardiology}>
                                        {
                                            FoundationsEnums.departments[
                                                FoundationsEnums.departments.Cardiology
                                            ]
                                        }
                                    </option>
                                </FoundationsSelect>
                            </div>
                        )}
                    </div>

                    <div className="form-group row mt-2">
                        <label className="col-sm-2 text-right control-label">Data Type:</label>
                        <div className="col-sm-4">
                            <FoundationsSelect
                                id="bp_datatype"
                                selectClasses="chzn-select"
                                name="dataType"
                                value={formData.dataType}
                                onChange={(e: any) => {
                                    handleInputChange(e)
                                }}
                                customStyles={{
                                    width: '200px',
                                    borderColor: '#D3D3D3',
                                    borderRadius: '5px',
                                }}
                            >
                                <option value="" disabled selected>
                                    - choose a type -
                                </option>
                                <option value={FoundationsEnums.HLDataType.HLCount}>
                                    {
                                        FoundationsEnums.HLDataType[
                                            FoundationsEnums.HLDataType.HLCount
                                        ]
                                    }
                                </option>
                                <option value={FoundationsEnums.HLDataType.HLNumber}>
                                    {
                                        FoundationsEnums.HLDataType[
                                            FoundationsEnums.HLDataType.HLNumber
                                        ]
                                    }
                                </option>
                                <option value={FoundationsEnums.HLDataType.HLDuration}>
                                    {
                                        FoundationsEnums.HLDataType[
                                            FoundationsEnums.HLDataType.HLDuration
                                        ]
                                    }
                                </option>
                                <option value={FoundationsEnums.HLDataType.HLMoney}>
                                    {
                                        FoundationsEnums.HLDataType[
                                            FoundationsEnums.HLDataType.HLMoney
                                        ]
                                    }
                                </option>

                                {/* Render options dynamically here */}
                            </FoundationsSelect>
                            <div
                                id="valmsg_bp_datatype"
                                className="field-validation-error"
                                style={{ display: errors.dataType ? 'block' : 'none' }}
                            >
                                {errors.dataType}
                            </div>
                        </div>
                    </div>
                    <div className="form-group row mt-2">
                        <label className="col-sm-2 text-right control-label">Value:</label>
                        <div className="col-sm-3">
                            <FoundationsInput
                                type="text"
                                inputClasses="form-control"
                                id="bp_datavalue"
                                value={formData.bpValue}
                                name="bpValue"
                                onInput={(e: any) => {
                                    handleInputChange(e)
                                }}
                                maxLength={10}
                                inputStyle={{ width: '200px', height: '32px' }}
                            />
                            <div
                                id="valmsg_bp_datavalue"
                                className="field-validation-error"
                                style={{ display: errors.bpValue ? 'block' : 'none' }}
                            >
                                {errors.bpValue}
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div
                                id="dataTypeMessage"
                                className="datatype-message"
                                style={{ color: '#D3D3D3', fontSize: '12px' }}
                                dangerouslySetInnerHTML={{ __html: validationMessage }}
                            >
                               
                            </div>
                        </div>
                    </div>
                    <div className="form-group row mt-2">
                        <label className="col-sm-2 text-right control-label">Valid Until:</label>
                        <div className="col-sm-3">
                            <DatePicker
                                inputClass="form-control BPDatepicker filter-date"
                                dateFormat="MM/DD/YYYY"
                                showIcon={false}
                                startingDate={
                                    formData.validUntil ? new Date(formData.validUntil) : null
                                }
                                setStartingDate={(date) => handleDateChange(date)}
                                placeholder=""
                                interval={1}
                                showTime={false}
                                onKeyDown={(e) => {
                                    e.preventDefault()
                                }}
                            />
                        </div>
                    </div>
                    <div className="form-group row mt-2">
                        <label className="col-sm-2 text-right control-label">IsSecured:</label>
                        <div className="col-sm-3">
                            <FoundationsCheckBox
                                id="bp_isSecured"
                                checked={formData.isSecured}
                                name="isSecured"
                                onChange={(e) => {
                                    handleInputChange(e)
                                }}
                                customStyles={{ height: '25px', width: '18px' }}
                            />
                        </div>
                    </div>
                    <div className="form-group mt-3">
                        <span
                            className="warning-business-parameter"
                            style={{ color: 'red', fontSize: '11px' }}
                        >
                            Warning: Business Parameter Values are visible to any users who can edit
                            Summary Report Targets and Report Filters. Sensitive data that should
                            not be available to such users should not be entered as a business
                            parameter.
                        </span>
                    </div>
                    <div className="form-group row mt-2">
                        <div className="col-sm-offset-2 row" style={{ marginLeft: '16.5%' }}>
                            <div className="col-sm-5">
                                <FoundationsButton
                                    type="button"
                                    buttonClasses="app-button"
                                    onClick={handleSave}
                                    id="save-button"
                                >
                                    Save
                                </FoundationsButton>
                            </div>
                            <div className="col-sm-5">
                                <FoundationsButton
                                    type="button"
                                    buttonClasses="app-button negative"
                                    onClick={handleCancel}
                                    id="cancel-button"
                                >
                                    Cancel
                                </FoundationsButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ManageBusinessParameters
